import React, { useEffect } from "react";
import { Stack } from "@mui/material";

import {
  HubButton,
  HubHookFormInput,
  HubHookFormWrapper,
  HubIcon,
} from "../../components";
import { usePostCreatePassword } from "../../hooks";
import { useNavigate } from "react-router-dom";

const ResetPasswordRequest = () => {
  const navigate = useNavigate();

  const {
    mutate: postCreatePasswordToken,
    isLoading,
    isSuccess,
  } = usePostCreatePassword();

  useEffect(() => {
    if (isSuccess) navigate("/reset?success=true");
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      email: formData?.email,
    };
    postCreatePasswordToken(payload);
  };

  return (
    <HubHookFormWrapper onSubmit={onSubmit}>
      <Stack width="100%" gap="25px" alignItems="center">
        <HubHookFormInput
          name="email"
          label="Email"
          placeholder="Enter your account email"
          startAdornment={<HubIcon icon="Mail" size={12} />}
          disabled={isLoading}
          required
          isEmail
        />
        <HubButton
          variant="contained"
          size="small"
          label="Reset Password"
          sx={{ width: "100%" }}
          disabled={isLoading}
          type="submit"
        />
      </Stack>
    </HubHookFormWrapper>
  );
};

export default ResetPasswordRequest;
